import Api from './Api';

export default {
  getForIndividuals: params => Api.get('/v1/user/managers/individualLessons', { params }),
};
